<div

  appClickComponent
  [dataComponent]= component()
  appPosition [position]="
  {
    top: component().properties.position.y,
    left: component().properties.position.x
   }"
  [ngStyle]="{
        'fontSize.px': component().properties.fontSize,
        'background-color':component().properties.background ?? 'white',
        'color': component().properties.colorText,
        'width.px':component().properties.size.width ,
        'height.px':component().properties.size.height ,
        'border-radius.px':component().properties.cornerRadius
        }"
  class="flex w-auto h-auto "
  [ngClass]="getAlignmentText(component().properties.textAlignment)"

><span class="w-auto h-auto text">{{ component().properties.text ?? 'Texto' }}</span>
</div>
